import * as React from 'react';

import {StreakEffectContainerConfigurationContext, frameworkStreakEffectContainer} from './streakeffectcontainerconfiguration';

const withStreakEffectContainerConfiguration = <P extends object>(
    WrappedComponent: React.ComponentType<P>): React.FC<P> => {
    const HOC = (props: any): React.ReactElement => (
        <StreakEffectContainerConfigurationContext.Consumer>
            {(auth: any): React.ReactElement => {
                return (
                    <WrappedComponent {...props}{...frameworkStreakEffectContainer}/>
                );
            }}
        </StreakEffectContainerConfigurationContext.Consumer>
    );

    HOC.displayName = `withAuthentication(${WrappedComponent.displayName || WrappedComponent.name})`;
    HOC.WrappedComponent = WrappedComponent;
    return HOC;
};

export default withStreakEffectContainerConfiguration;